<template>
  <b-modal
    :active.sync="showModal"
    full-screen
  >
    <div
      class="modal-card"
      style="width: auto"
    >
      <header
        class="modal-card-head is-block "
        style="padding: 28px 32px 8px 32px;"
      >
        <onboarding-wizard-header
          active-step="account"
          :plan-clickable="true"
          @plan-clicked="handleChangePlanClick"
        />
      </header>
      <section class="modal-card-body">
        <div class="container">
          <div class="columns is-centered is-vcentered">
            <div class="column is-one-third">
              <img
                src="@/assets/sonata-logo.svg"
                width="224"
                height="60"
              >
              <br>
              <br>
              <div v-if="selectedPlan">
                <div class="columns">
                  <div class="column">
                    <span
                      class="icon-static xl margin-bottom-l ml-0 is-pulled-left"
                      :class="selectedPlan.slug"
                    />
                    <h3 class="title-wide is-3 mt-5 is-pulled-left">
                      <span v-if="trialMode">30-day {{ selectedPlan.product_name }} trial</span>
                      <span v-else>You chose {{ selectedPlan.product_name }}</span>
                    </h3>
                    <p
                      class="text color-bluegrey1 mt-0 mb-0"
                      style="clear: both;"
                    >
                      {{ selectedPlan.description }}
                    </p>
                    <h3 class="title-lowercase is-5 mb-3 mt-5">
                      {{ selectedPlan.amount|formattedDbAmount('', 2, selectedPlan.currency) }} <small>/ {{ selectedPlan.interval }}<span v-if="trialMode"> after trial ends</span></small>
                    </h3>
                    <p v-if="trialMode">
                      No charge if you cancel in first 30 days.
                    </p>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-10">
                    <button
                      class="button is-primary is-large is-rounded"
                      @click="handleChangePlanClick"
                    >
                      Change plan?
                    </button>
                    <hr
                      class="mt-5 mb-0 has-background-grey-lighter"
                      style="height: 1px;"
                    >
                  </div>
                </div>
                <div class="columns perfect-for mb-0">
                  <div class="column is-10">
                    <ul>
                      <li
                        v-for="item in selectedPlan.details ? selectedPlan.details.split('\n').slice(0, 3) : []"
                        :key="item"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div> <!-- /Selected plan -->
            </div>
            <div class="column is-half pt-6">
              <form
                class="form"
                @submit.prevent="signup"
              >
                <section
                  v-if="!complete"
                >
                  <h3 class="title is-3 mt-5 mb-5">
                    Create your account
                  </h3>
                  <div
                    v-for="(err, i) in formErrors.non_field_errors"
                    :key="i"
                    class="message is-danger has-text-left"
                  >
                    <div class="message-body">
                      {{ err }}
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Your name</label>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input
                            id="id_first_name"
                            v-model.trim="signupData.user.first_name"
                            :class="errorClass('user.first_name')"
                            required
                            type="text"
                            name="first_name"
                            class="input"
                            placeholder="First"
                          >
                        </div>
                      </div>
                      <div class="field">
                        <div class="control">
                          <input
                            id="id_last_name"
                            v-model.trim="signupData.user.last_name"
                            :class="errorClass('user.last_name')"
                            required
                            type="text"
                            name="last_name"
                            class="input"
                            placeholder="Last"
                          >
                        </div>
                      </div>
                    </div>
                    <!-- /.field-body -->
                    <p
                      v-for="(err, i) in getErrors('user.first_name')"
                      :key="i"
                      class="help is-danger has-text-left"
                    >
                      {{ err|capitalize }}
                    </p>
                    <p
                      v-for="(err, i) in getErrors('user.last_name')"
                      :key="i"
                      class="help is-danger has-text-left"
                    >
                      {{ err|capitalize }}
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">Email address</label>
                    <div class="control">
                      <input
                        id="id_email"
                        v-model.trim="signupData.user.email"
                        :class="errorClass('user.email')"
                        required
                        type="email"
                        name="email"
                        class="input"
                        placeholder="Email address"
                      >
                    </div>
                    <p
                      v-for="(err, i) in getErrors('user.email')"
                      :key="i"
                      class="help is-danger has-text-left"
                    >
                      {{ err|capitalize }}
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">Password</label>
                    <div class="control">
                      <input
                        id="id_password"
                        v-model.trim="signupData.user.password"
                        :class="errorClass('user.password')"
                        required
                        type="password"
                        name="password"
                        class="input"
                        placeholder="Password"
                      >
                    </div>
                    <p
                      v-for="(err, i) in getErrors('user.password')"
                      :key="i"
                      class="help is-danger has-text-left"
                    >
                      {{ err|capitalize }}
                    </p>
                  </div>
                  <div
                    class="field"
                    style="padding: 16px 0 0 0"
                  >
                    <b-checkbox
                      v-model="signupData.agreed_to_terms"
                    >
                      <span
                        class="text medium"
                        style="padding-left: 6px;"
                      >
                        I have read and agree to the
                        <a
                          href="/terms"
                          target="_blank"
                        >Terms and Conditions.</a>
                      </span>
                    </b-checkbox>
                    <br>
                    <b-checkbox
                      v-model="signupData.has_agreed_to_marketing_email"
                    >
                      <span
                        class="text medium"
                        style="padding-left: 6px;"
                      >
                        Keep me informed about new music, updates and offers.
                      </span>
                    </b-checkbox>
                  </div>
                  <div
                    v-if="!complete"
                  >
                    <p
                      v-if="!trialMode"
                      class="text medium has-text-centered"
                    >
                      No credit card required
                    </p>
                    <br>
                    <button
                      type="submit"
                      :disabled="!signupData.agreed_to_terms || busy"
                      class="button is-fullwidth is-large is-accent margin-bottom"
                      :class="{ 'is-loading': busy }"
                      v-html="signupButtonLabel"
                    />
                    <p class="text medium has-text-centered">
                      <a @click.prevent="handleShowLogin">Have an account? Log in</a>
                    </p>
                  </div>
                  <div
                    v-if="complete"
                  />
                </section>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import OnboardingWizardHeader from '@/components/OnboardingWizardHeader.vue'
import teamClient from '@/api/teams.js'
import { formatComponentName } from '@/utils/common.js'
import { identify as segmentIdentify, logSignup } from '@/utils/segment.js'
import { identify as logrocketIdentify } from '@/utils/logrocket.js'

export default {
  name: 'TheSignupModal',

  components: {
    OnboardingWizardHeader
  },

  data () {
    return {
      signupData: {
        campaign: null, // UTM source, medium, etc.
        agreed_to_terms: false,
        has_agreed_to_marketing_email: true,
        client_terms_agreed_at: null,
        user: {
          email: '',
          first_name: '',
          last_name: '',
          password: ''
        },
        team: {
          name: ''
        }
      },
      formErrors: {},
      busy: false,
      complete: false
    }
  },

  computed: {
    showModal: {
      get: function () {
        return this.$store.getters['user/showSignupModal']
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.dispatch('user/showSignupModal')
        } else {
          // Closed by the user without logging in, so forget where they were headed.
          // Otherwise a later login would send them back to that page.
          this.$store.dispatch('user/hideSignupModal')
          this.$store.dispatch('auth/clearRedirectTo')
        }
      }
    },

    fullName: function () {
      return (
        this.signupData.user.first_name +
        ' ' +
        this.signupData.user.last_name
      ).trim()
    },

    componentName: function () {
      return formatComponentName(this)
    },

    title: function () {
      if (this.$store.getters['subscriptions/createSubscriptionWithTrial']) {
        return 'Start your free trial now!'
      }
      return 'Start for free now'
    },

    trialMode: function () {
      return this.$store.getters['subscriptions/createSubscriptionWithTrial']
    },

    signupButtonLabel: function () {
      return 'Proceed to confirmation'
    },

    selectedPlan: function () {
      return this.$store.getters['subscriptions/selectedPlan']
    }
  },

  mounted () {
    // Grab any cookie-stored UTM campaign data for sending to server to store.
    this.signupData.campaign = this.$cookies.get('__campaign') || null
  },

  methods: {
    signup () {
      this.formErrors = {}

      if (this.signupData.team.name.trim() === '') {
        this.signupData.team.name = this.fullName
      }

      this.signupData.client_terms_agreed_at = new Date().toISOString()

      const vm = this
      vm.busy = true

      teamClient
        .register(this.signupData)
        .then(() => {
          this.login()
          // Clear sensitive data from local store.
          this.signupData.user.password = ''
          logSignup()
        })
        .catch(error => {
          const status = error.response && error.response.status
          if (status === 400) {
            this.$set(this, 'formErrors', error.response.data)
            vm.busy = false
            return
          }
          if (status === 429) {
            const errors = { non_field_errors: ['Too many requests. Please wait a few minutes and try again.'] }
            this.$set(this, 'formErrors', errors)
            vm.busy = false
            return
          }
          const errors = { non_field_errors: ['Something went wrong signing up. Please try again.'] }
          this.$set(this, 'formErrors', errors)
          vm.busy = false
          return Promise.reject(error.response || error)
        })
    },

    login () {
      const email = this.signupData.user.email
      const password = this.signupData.user.password

      this.$store.dispatch('auth/login', {
        email,
        password
      })
        .then(
          () => this.completeSignup(),
          (error) => {
            // The account now exists, so signing up again would fail.
            const errors = { non_field_errors: ['Your account was created but we couldn\'t log you in. Please log in with your email and password.'] }
            this.$set(this, 'formErrors', errors)
            this.busy = false
            return Promise.reject(error.response || error)
          }
        )
    },

    completeSignup () {
      // The user is logged in from here on. If loading their account fails, still close
      // the modal rather than leave it spinning.
      return this.$store.dispatch('common/initAuthenticated')
        .then(() => {
          const user = this.$store.getters['user/currentUser']
          const team = this.$store.getters['user/currentTeam']

          const userTraits = {
            email: user.email,
            name: (user.first_name + ' ' + user.last_name).trim(),
            team: team.name
          }

          segmentIdentify(user.pk, userTraits)
          logrocketIdentify(user.pk, userTraits)
        })
        .finally(() => {
          this.busy = false
          this.complete = true

          const authRedirectTo = this.$store.getters['auth/redirectTo']
          this.$store.dispatch('auth/hideLoginModal')
          this.$store.dispatch('user/hideSignupModal')
          this.$store.dispatch('auth/clearRedirectTo')

          // Redirect to correct place ... or show modal!
          if (this.$store.getters['subscriptions/selectedPlan']) {
            this.$router.push({ name: 'subscription-checkout' })
          } else {
            if (authRedirectTo) {
              this.$router.push(authRedirectTo)
            } else if (this.$route.name !== 'track-search') {
              // Only redirect if we're not on the track search page.
              this.$router.push({ name: 'track-search' })
            }
          }
        })
    },

    getErrors (path) {
      const parts = path.split('.')
      return parts.reduce((p, c) => (p && p[c]) || null, this.formErrors)
    },

    isValid (path) {
      return this.getErrors(path) === null
    },

    errorClass (path) {
      return !this.isValid(path) ? 'is-danger' : ''
    },

    handleShowLogin () {
      this.$store.dispatch('user/hideSignupModal')
      this.$store.dispatch('auth/showLoginModal')
    },

    handleChangePlanClick: function () {
      this.$store.dispatch('subscriptions/selectPlan', null)
      this.$store.dispatch('subscriptions/showPlanSelectionModal')
    },

    handleShowArtistSubmissionsPage () {
      this.$store.dispatch('user/hideSignupModal')
      this.$router.push({ name: 'artist-submissions' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.success-login {
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}
li {
  list-style-image: url("~@/assets/icons/small-checkmark.svg");
  font-size: $size-5;
  margin-bottom: 16px;
  margin-left: 20px;
}
</style>
